export default class DtoWatermassLink {
    constructor(obj = {}) {
        this.idStation = obj.idStation
        this.watermassCode = obj.watermassCode
    }
}